module.exports = __webpack_public_path__ + "static/media/18ECA18.72fd8d2f.jpg";